// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCZpGDEmbQYaKi6k_haeZcgJcpQbqaI0ps',
    authDomain: 'fairchain-loyalty.firebaseapp.com',
    databaseURL:
      'https://fairchain-loyalty-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'fairchain-loyalty',
    storageBucket: 'fairchain-loyalty.appspot.com',
    messagingSenderId: '1004821067901',
    appId: '1:1004821067901:web:41ed34b11e434a55fc5914',
    measurementId: 'G-80V07PN3ST',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
